import axios from '@/services/request';
import {AxiosPromise} from "axios";
import store from "@/store";
// @ts-ignore
import qs from 'qs'
import {AdCreateInfo} from "@/model/AdCreateInfo";
import {Account, AccountReq, AccountStatusReq} from "@/model/Account";
import {Resp, Page, Resp2} from "@/model/Resp";
import {
  OverviewReq,
  OverviewResp,
  ReportOnlineReq,
  ReportOnlineResp,
  ReportOrderReq,
  ReportOrderResp
} from "@/model/Report";

/**
 * 查询未审核的item列表
 * @param country
 * @param language
 * @param showLoading
 * @returns {AxiosPromise}
 */
export function getLatestItemInfo(country: string, language: string, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/audit_interface/getLatestItemInfo?country=${country}&language=${language}`)
}


/**
 * 查询未审核的item列表
 * @param country
 * @param language
 * @param auditType
 * @param showLoading
 * @returns {AxiosPromise}
 */
export function getAuditInfo(country: string, language: string, auditType: string, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/audit_interface/pull/audit_info?country=${country}&language=${language}&auditType=${auditType}`)
}

/**
 * 提交item
 * @param itemForm
 * @param showLoading
 * @returns {AxiosPromise}
 */
export function saveAuditInfo(itemForm: any, showLoading: boolean = true): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/audit_interface/save/audit_info`, itemForm)
}

/**
 * 提交审核
 * @param data
 * @param showLoading
 */
export function updateAuditInfo(data: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  data = qs.stringify(data)
  return axios.post(`/api/audit_interface/updateAuditInfo`, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 今日已审核item数量
 */
export function showCountGroupByCountry(auditType = '', showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/audit_interface/showCountGroupByCountry?auditType=${auditType}`)
}

/**
 * 今日未审核item数量
 */
export function noAuditCountGroupByCountry(auditType = '', showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/audit_interface/noAuditCountGroupByCountry?auditType=${auditType}`)
}

/**
 * 查询item和关联的套餐信息
 * @param itemId
 * @param showLoading
 */
export function getItemInfo(itemId: number, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/audit_interface/getItemDetail?itemId=${itemId}`)
}
/**
 * 查询item详细信息
 * @param itemId
 * @param showLoading
 */
export function itemDetail(itemId: number, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/audit_interface/getItem?id=${itemId}`)
}

/**
 * 更新item及关联的套餐信息
 * @param item
 * @param showLoading
 */
export function updateItemInfo(item: {
  itemId: number,   //产品id
  itemTitle: string,  //item标题
  itemPrice: number,   //item价格
  goodList: any[],    //套餐列表
  covers: string[]   //轮播图
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.put(`/api/audit_interface/saveItem`, item)
}
/**
 * 更新item信息
 * @param item
 * @param showLoading
 */
export function updateItemDetail(item: {
  id: number,   //产品id
  assetTitle: string,  //广告标题
  assetBody: string //广告体
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.put(`/api/audit_interface/editItem`, item)
}

/**
 * 登录
 * @param params
 * @param showLoading
 */
export function login(params: {
  userName: string,   // 用户
  password: string    // 密码
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/user/login`, params)
}

/**
 * 登出
 * @param params
 * @param showLoading
 */
export function logout(params: {
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/user/logout`, {params})
}


/**
 * 获取登录用户信息
 * @param params
 * @param showLoading
 */
export function userInfo(params: {
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/user/baseInfo`, {params})
}

/**
 * 编辑工具item列表
 * @param params
 * @param showLoading
 */
export function getEditItemList(params: {
  country?: string,
  language?: string,
  itemId?: number,
  tempLinkUrl?: string,
  creater?: string,
  startDate?: string,
  endDate?: string,
  currency?: string,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/itemList`, params)
}

/**
 * 站点列表
 * @param params
 * @param showLoading
 */
export function getStationList(params: {
  country?: string,
  title?: string,
  itemId?: number,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/staticPages`, params)
}

/**
 * 本人item列表
 * @param params
 * @param showLoading
 */
export function getMyItemList(params: {
  country?: string,
  language?: string,
  itemId?: number,
  tempLinkUrl?: string,
  startDate?: string,
  endDate?: string,
  currency?: string,
  pageNo: number,
  pageSize: number
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/myItemList`, params)
}

/**
 * id获取item详情
 * @param copyItemId
 * @param showLoading
 */
export function getDetailById(copyItemId: number, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/genData`,  {copyItemId})
}

/**
 * url获取item详情
 * @param linkURL
 * @param showLoading
 */
export function getDetailByUrl(linkURL: string, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/genData`, {linkURL})
}


/**
 * 通过图片地址进行查重
 * @param linkURL
 * @param showLoading
 */
export function similarSearchByImage(params: {country: string, image: string}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/similar/searchByImage`, params)
}

/**
 * 通过投手参考链接查询相似spuId
 */
export function getSpuSimilar(params: {supperLinkUrl: string}, showLoading: boolean = false): AxiosPromise<Resp<number[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`https://atm2oms.zfkunyu.com/api/out/spu/similar/ids`, params)
}

/**
 * item修改
 * @param params
 * @param showLoading
 */
export function saveEditItemDetail(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/saveData`, params)
}

/**
 * 拷贝item
 * @param params
 * @param showLoading
 */
export function copyItem(params: {copyItemId: number, country: string}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/copyData`, params)
}

/**
 * 获取配置
 * @param params
 * @param showLoading
 */
export function getConfig(params: {
  type: 'region'|'language'|'toushou'|'domain'|'accountPageStatus'|'orderStatus'
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/config/datas`, {params})
}

/**
 * 获取模板配置
 * @param params
 * @param showLoading
 */
export function getModelConfig() {
  return axios.get(`https://services.a.deliver-assistant.zfkunyu.com/api/getConfigModel`)
}

/**
 * 保存落地页信息
 * @param params
 * @param showLoading
 */
export function saveLangdingPage(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/landingPage`, params)
}

/**
 * 保存域名信息
 * @param params
 * @param showLoading
 */
export function saveDomainConfig(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/saveDomainConfig`, params)
}

/**
 * 修改像素
 * @param params
 * @param showLoading
 */
export function updatePixel(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/updatePixel`, params)
}

/**
 * 修改域名
 * @param params
 * @param showLoading
 */
export function updateDomain(params: any, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/updateDomain`, params)
}


/**
 * 新增域名
 * @param params
 * @param showLoading
 */
export function addDomain(params: {domain: string}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/manage/add`, {params})
}


/**
 * 删除域名
 * @param params
 * @param showLoading
 */
export function deleteDomain(params: {domain: string}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/manage/delete`, {params})
}

/**
 * 创建广告
 * @param params
 * @param showLoading
 */
export function createAd(params: AdCreateInfo, showLoading: boolean = true): AxiosPromise<Resp<AdCreateInfo>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/ad/createAd`, params)
}

/**
 * 根据pixel获取账号列表
 * @param params
 * @param showLoading
 */
export function getAccountList(params: {pixelId: string}, showLoading: boolean = false): AxiosPromise<Resp<{code: string, desc: string, available: boolean}[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/facebookDeliver/ad/accountList`, {params})
}

/**
 * 根据账号获取page列表
 * @param params
 * @param showLoading
 */
export function getPageList(params: {accountId: string}, showLoading: boolean = false): AxiosPromise<Resp< {code: string, desc: string}[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/facebookDeliver/ad/pageList`, {params})
}

/**
 * 获取我的账户列表
 * @param params
 * @param showLoading
 */
export function getMyAccountList(params: AccountReq, showLoading: boolean = false): AxiosPromise<Resp<Page<Account>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/facebookDeliver/account/myAccountList`, {params})
}

/**
 * 验证账户
 * @param params
 * @param showLoading
 */
export function verifyAccountStatus(params: AccountStatusReq, showLoading: boolean = false): AxiosPromise<Resp<string>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/account/verifyStatus`, params)
}

/**
 * 停用账户
 * @param params
 * @param showLoading
 */
export function stopAccount(params: AccountStatusReq, showLoading: boolean = false): AxiosPromise<Resp<string>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/account/stopAccount`, params)
}

/**
 * 删除账户
 * @param params
 * @param showLoading
 */
export function deleteAccount(params: AccountStatusReq, showLoading: boolean = false): AxiosPromise<Resp<string>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/account/deleteAccount`, params)
}

/**
 * 获取excel模板
 */
export function getTempExcel(params: {}, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/facebookDeliver/excel/temp/downloadAccountPage`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 上传文件接口
 * @param params
 * @param showLoading
 */
export function uploadAccountPage(params: FormData, showLoading: boolean = true): AxiosPromise<Resp<any>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/facebookDeliver/excel/upload/accountPage`, params)
}

/**
 * 图片查重
 * @param params
 * @param showLoading
 */
export function checkDuplicate(params: {itemId: number, country: string, image: string}, showLoading: boolean = true): AxiosPromise<Resp2<any[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/item_create/similar/itemByImage`, params)
}


/**
 * 数据总览
 * @param params
 * @param showLoading
 */
export function getOverviewList(params: OverviewReq, showLoading: boolean = true): AxiosPromise<Resp<Page<OverviewResp>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/report/overviewList`, {params})
}

/**
 * 订单数据
 * @param params
 * @param showLoading
 */
export function getOrderList(params: ReportOrderReq, showLoading: boolean = true): AxiosPromise<Resp<Page<ReportOrderResp>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/report/orderList`, {params})
}

/**
 * 在投数据
 * @param params
 * @param showLoading
 */
export function getOnlineList(params: ReportOnlineReq, showLoading: boolean = true): AxiosPromise<Resp<Page<ReportOnlineResp>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/report/onlineList`, {params})
}

/**
 * 获取excel
 */
export function getOverviewExcel(params: OverviewReq, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/report/overviewExcel`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export function getOrderExcel(params: ReportOrderReq, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/report/orderExcel`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export function getOnlineExcel(params: ReportOnlineReq, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/report/onlineExcel`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}